(() => {
  const root = document.documentElement;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function finishLoader() {
    root.classList.add('tt-loader-finished');
    root.classList.remove('tt-show-loader');
    try {
      sessionStorage.setItem('techticLoaderSeen', '1');
      sessionStorage.removeItem('techticNavigationPending');
    } catch (error) {
      root.dataset.loaderStorage = 'unavailable';
    }
  }

  function startLoader() {
    if (prefersReducedMotion) return;
    root.classList.remove('tt-loader-finished');
    root.classList.add('tt-show-loader');
  }

  function initLoader() {
    let navigationPending = false;
    try {
      navigationPending = Boolean(sessionStorage.getItem('techticNavigationPending'));
    } catch (error) {
      root.dataset.loaderStorage = 'unavailable';
    }

    if (!root.classList.contains('tt-show-loader') || prefersReducedMotion) {
      finishLoader();
      return;
    }
    const finishDelay = navigationPending ? 480 : 240;
    if (document.readyState === 'complete') window.setTimeout(finishLoader, finishDelay);
    else window.addEventListener('load', () => window.setTimeout(finishLoader, finishDelay), { once: true });
    window.setTimeout(finishLoader, 1600);
  }

  function initHomeMotion() {
    if (window.location.pathname !== '/' || prefersReducedMotion) return;
    root.classList.add('tt-home-motion');

    const main = document.querySelector('#MainContent');
    if (!main) return;

    const sections = Array.from(main.querySelectorAll(':scope > .shopify-section, :scope > [id^="shopify-section-"]'));
    const hero = sections[0];
    if (hero) {
      hero.classList.add('tt-home-hero');
      window.requestAnimationFrame(() => hero.classList.add('is-visible'));
    }

    const revealTargets = sections.slice(1);
    revealTargets.forEach((section) => section.classList.add('tt-reveal'));

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    revealTargets.forEach((section) => observer.observe(section));
  }

  function initPageTransitions() {
    document.addEventListener('click', (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[href]');
      if (!link || link.target && link.target !== '_self' || link.hasAttribute('download')) return;

      const destination = new URL(link.href, window.location.href);
      if (destination.origin !== window.location.origin) return;
      if (destination.pathname === window.location.pathname && destination.search === window.location.search && destination.hash) return;
      // Wokiee uses the plain search URL to open its search drawer without navigating.
      if (destination.pathname === '/search' && !destination.search) return;
      if (link.hasAttribute('aria-controls') || link.getAttribute('role') === 'button') return;

      try {
        sessionStorage.setItem('techticNavigationPending', '1');
      } catch (error) {
        root.dataset.loaderStorage = 'unavailable';
      }
      startLoader();

      const currentLocation = window.location.href;
      window.setTimeout(() => {
        if (window.location.href === currentLocation && !document.hidden) finishLoader();
      }, 1800);
    }, true);
  }

  initLoader();
  initPageTransitions();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHomeMotion, { once: true });
  } else {
    initHomeMotion();
  }
})();
